export const categoryList = ["restaurants", "cafes", "games", "shopping", "spa",
"bowling", "karaoke", "bars", "clubs", "billiards",
"theaters", "zoo", "amusement parks", "parks", "beach and pool"];